import { endPoints as EndPoints } from '../../../../constants/PosConstants'
import PosStore from '../../../../stores/PosStore';
import PosActions from '../../../../actions/PosActions';
import UserStore from '../../../../stores/UserStore';
import PosCartStore from '../../../../stores/PosCartStore';
import AjaxPromises from '../../../../utils/AjaxPromises';
import PosCartActions from '../../../../actions/PosCartActions';
import PopupActions from '../../../../actions/PopupActions';
import NotificationActions from '../../../../actions/NotificationActions';


class AddFeeDonation extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            load        : false,
            selected    : false,
            amount      : 0,
            calculationMethod : '',
            calculationMethodId : 0,
            cashValue    : 0,
            description : '',
        };

        this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
        this.addFeeDonation = this.addFeeDonation.bind(this);
        this.onAmountChange = this.onAmountChange.bind(this);
        this.onCalculationMethodChange = this.onCalculationMethodChange.bind(this);
        this.onDescriptionChange = this.onDescriptionChange.bind(this);
    }

    componentDidMount(){
        if (_.isEmpty(PosStore.getState().calculationMethods)) {
            PosActions.getCalculationMethods();
        }
    }

    componentWillReceiveProps(next) {
        if (!next.selectedFeeDonation) {
            return;
        }

        var selected = '';
        if (next.selectedFeeDonation.CalculationMethodId === 1) {
            selected = 'amount';
        }

        if (next.selectedFeeDonation.CalculationMethodId === 2) {
            selected = 'percent';
        }

        if (next.selectedFeeDonation.CalculationMethodId === 3) {
            selected = 'round-up';
        }

        this.setState({
            selected: selected,
            amount: next.selectedFeeDonation.CalculationValue,
            calculationMethod: next.selectedFeeDonation.CalculationMethod,
            calculationMethodId: next.selectedFeeDonation.CalculationMethodId,
            description: next.selectedFeeDonation.Name,
        });
    }

    componentDidUpdate(prevProps){
        if(prevProps.selectedFeeDonation !== this.props.selectedFeeDonation){
            this.calculateCashValue()
        }

        if(prevProps.calculationMethodId !== this.props.calculationMethodId){
            this.calculateCashValue()
        }
    }

    onAmountChange(e) {
        this.setState({ amount : e.target.value },
            () => {
                this.calculateCashValue()
            });
    }

    selected(selected) {
        this.setState({ selected });
    }

    onCalculationMethodChange(e) {
        this.setState({ 
            calculationMethod   : e.target[e.target.selectedIndex].text,
            calculationMethodId : parseInt(e.target.value),
        }, () =>{
            this.calculateCashValue()
        });

        if(e.target.value == 1) {
            this.selected('amount')
        } else if(e.target.value == 2){
            this.selected('percent')
        } else{
            this.selected('round-up')
        }
    }

    onDescriptionChange(e) {
        this.setState({ description : e.target.value });
    }

    calculateCashValue(){
        var cartSummary             = PosCartStore.getCartSummary();
        var subtotal                = cartSummary.subTotal.flt
        var roundeddown             = cartSummary.roundedDown.flt
        var discount                = cartSummary.discount.flt
        var calculationMethodId     = this.state.calculationMethodId
        var calculationValue        = _.round((this.state.amount), 2)
        var cashValue               = 0.00

        if(calculationValue <= 0) {
            this.setState({
                cashValue : 0.00,
            })

            return 0.00
        }

        if(calculationMethodId === 1) {
            cashValue = calculationValue
        } else if(calculationMethodId === 2) {
            cashValue = (subtotal-discount) * (calculationValue/100.00)
        } else if(calculationMethodId === 3) {
            cashValue = calculationValue - roundeddown % calculationValue
        }

        this.setState({
            cashValue : _.round(cashValue, 2),
        })

        return _.round(cashValue, 2)
    }

    addFeeDonation() {
        if (!this.state.selected) {
            return;
        }

        var selectedFeeDonation = this.props.selectedFeeDonation
        var guest               = this.props.guest

        var formData = UserStore.getApiData();
        formData.ShipmentId               = this.props.guest.ShipmentId
        formData.FeeDonationId            = selectedFeeDonation.FeeDonationId
        formData.CalculationMethodId      = this.state.calculationMethodId
        formData.CalculationValue         = parseInt(this.state.amount)
        formData.CashValue                = this.calculateCashValue()
        formData.Description              = this.state.description

        this.apply(formData, guest)
    }

    apply(formData, guest) {
        this.setState({ load : true}, () => {
            AjaxPromises.POST(EndPoints.APPLY_FEE_DONATION, formData)
            .then(res => {
                if(res.Result){
                    NotificationActions.addNotification({ type : 'success', body : 'Fee/Donation Applied Successfully' });
                    PosCartActions.loadUserCart(guest.Guest_id, guest.ShipmentId);
                    PopupActions.close();
                }
                else{
                    NotificationActions.addNotification({ type : 'error', body : 'Failed to apply fee/donation' });
                }
            })
        })
    }

    render() {
        var selectedFeeDonation  = this.props.selectedFeeDonation;
        var amount      = '';
        var selected    = this.state.selected;
        var calculationMethods = PosStore.getState().calculationMethods;

        return (
            <div className='add-discount'>

                <div className='add-discount__header'>
                    <div className='add-discount__header--name'>
                        {selectedFeeDonation.Name}
                    </div>

                    <div className='add-discount__header--amount'>
                        {amount}
                    </div>
                </div>

                { !selectedFeeDonation &&
                    <div className='add-discount__overlay'>
                        <div className='add-discount__overlay--label'>
                            Select Fee or Donation to proceed
                        </div>
                    </div>
                }

                <div className='add-discount__item add-discount__item--to'>
                    <div className='add-discount__item--title'>
                        Application Type
                    </div>

                    <select
                        value={this.state.calculationMethodId}
                        onChange={this.onCalculationMethodChange} >
                        {
                            calculationMethods.map(x => {
                                return(
                                <option value={x.CalculationMethodId}>{x.CalculationMethod}</option>
                                )
                            })
                        }
                    </select>
                </div>

                <div className='add-discount__item add-discount__item--amount'>
                    {this.state.selected !== 'round-up' 
                        ? 
                            <div className='add-discount__item--title'>
                                {this.state.selected === 'amount' ? 'Flat Amount' : 'Percent Of Sub-Total'}
                            </div>
                        :
                            <div className='add-discount__item--title'>
                                Round-up
                            </div>
                    }

                    <input
                        className=''
                        type='text'
                        onChange={this.onAmountChange}
                        value={this.state.amount}
                    />

                    <div className={'add-discount__item--label'}>
                        {selected === 'percent' ? '%' : '$'}
                    </div>
                </div>

                <div className='add-discount__item add-discount__item--perc'>
                    <div className='add-discount__item--title'>
                        Calculated Amount
                    </div>

                    <input
                        className=''
                        type='text'
                        value={this.state.cashValue}
                        disabled='disabled'/>
                    
                    <div className='add-discount__item--label'>
                        {'$'}
                    </div>

                </div>

                <div className='add-discount__item add-discount__item--desc'>
                    <div className='add-discount__item--title'>
                        Description
                    </div>

                    <textarea
                        onChange={this.onDescriptionChange} 
                        value={this.state.description}/>
                </div>          

                <div
                    className={'add-discount__apply '+(!selectedFeeDonation || !this.state.selected ? 'btn-green__disabled' : '')}
                    onClick={this.addFeeDonation}>

                    Apply
                </div>

            </div>
        );
    }
}

export default AddFeeDonation;



// WEBPACK FOOTER //
// ./ui_src/app/components/pos/sidebar/feesDonations/AddFeeDonation.react.jsx